module.exports = __webpack_public_path__ + "img/02基本資訊.4da39f09.jpg";